import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import ERPImage from "../Images/CRMImage.jpg";
import { project_name } from "../Config/config";
import SEO from "../components/SEO";  

export default function WhyChooseUs() {
  return (
    <>
      <SEO  
        title={`Why Choose ${project_name} AI ERP & CRM? | EnteliPro`}
        description={`Discover why ${project_name} is the best AI ERP and CRM solution for your business. Secure, mobile-friendly, and built for growth with flexible pricing.`}
        keywords={`Why Choose ${project_name}, AI ERP Software, CRM Solutions, Business Management Software, Cloud ERP, Customer Relationship Management`}
        canonical="https://www.entelipro.com/whychooseus"
        ogImage="https://www.entelipro.com/static/media/ERPImage.jpg"
      />

      <Navbar />
      {/* breadcrumbs */}
      <section className="w3l-inner-banner-main">
        <div className="about-inner inner2">
          <div className="container seen-w3">
            <ul className="breadcrumbs-custom-path">
              <li>
                <Link to="/">
                  Home{" "}
                  <span className="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>
              <li className="active">Why Choose {`${project_name}`}?</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="w3l-content-with-photo-4">
        <div className="content-with-photo4-block">
          <div className="container">
            <div className="cwp4-two row">
              <div className="col-xl-6 cwp4-image ">
                <img
                  src={ERPImage}
                  alt={`${project_name} AI ERP and CRM Software Platform`}  
                  className="img-responsive "
                />
              </div>
              <div className="cwp4-text col-xl-6">
                <h1 className="header-name" style={{ fontSize: "2.3rem", fontWeight: "700", marginBottom: "1rem" }}>  
                  Why Choose {`${project_name}`}?
                </h1>
                <p className="para">
                  With more than 5 years of experience in the ERP industry, we
                  know what it's like to be at every stage of a growing
                  business. Since our start, we have grown to support customers
                  by putting their needs at the center of everything we do. We
                  have got your back today, tomorrow, and all the days ahead.
                  <br />
                  <br />
                  {`${project_name}`} makes customer service better. We build
                  software to meet customer needs, set your team up for success,
                  and keep your business in sync.
                </p>
                <br />
                <Link to="/login" className="btn action-button mt-6">  
                  Get Free ERP
                </Link>
              </div>
              <div className="left-text">
                <h3 style={{ fontSize: "45px" }}>
                  {`${project_name}`} is not
                  <br />
                  just different, it's better.
                </h3>
                <br />
                <p className="para">
                  ERP software is used by organizations to run their sales
                  processes. While these solutions might be user-friendly
                  robust, and secure, the amount of complexity leads to the user
                  experience suffering, which often requires you to change the
                  way you work to suit the software.
                </p>
                <br />

                <p className="para">
                  {`${project_name}`} with its broad coverage, deep features can
                  go head to head when it comes to technology and functionality.
                  Where other ERPs use predatory business practices and
                  aggressive, multi-year contracts to strong-arm users into
                  sticking around, we are so confident in the strength of our
                  product that we offer flexible, month-to-month subscriptions
                  that can grow with your business.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w3l-specification-6">
        <div className="specification-layout">
          <div className="container">
            <div className="main-titles-head">
              <h3 className="header-name">
                We Bring The Best Services For You
              </h3>
            </div>
            <div className="specification-effect row text-center">
              <div className="grids-effect-2 col-lg-4 col-md-6 col-sm-6">
                <div className="back-color">
                  <span className="fa fa-shield" aria-hidden="true"></span>
                  <h4>
                    <Link to="/security" className="title-head"> 
                      Secure and Reliable
                    </Link>
                  </h4>
                  <p className="para">
                    With advanced security features like encryption, audit logs,
                    IP restrictions, and two-factor authentication,{" "}
                    {`${project_name}`} conveniently protects your data, only
                    allowing access to the users you authorize.
                  </p>
                </div>
              </div>
              <div className=" grids-effect-2 col-lg-4 col-md-6 col-sm-6">
                <div className="back-color">
                  <span className="fa fa-mobile" aria-hidden="true"></span>
                  <h4>
                    <Link to="/digitalmobile" className="title-head"> 
                      Mobile Accessibility
                    </Link>
                  </h4>
                  <p className="para">
                    If you have a sales team in the field, it's important to
                    ensure that they have access to customer data at all times.
                    {`${project_name}`} allows them to stay on the move, close
                    deals more effectively, and keep everyone in the loop.
                  </p>
                </div>
              </div>
              <div className="grids-effect-2 col-lg-4 col-md-6 col-sm-6">
                <div className="back-color">
                  <span className="fa fa-phone-square" aria-hidden="true"></span>
                  <h4>
                    <Link to="/contact_us" className="title-head">  
                      Customer Support
                    </Link>
                  </h4>
                  <p className="para">
                    With our support system, you will have access to a team of
                    highly skilled support engineers on standby 24 hours a day,
                    all year long. They can assist you with all your issues, big
                    and small, generating solutions in the average period.
                  </p>
                </div>
              </div>
              <div className="grids-effect-2 col-lg-4 col-md-6 col-sm-6 mt-4 pt-1">
                <div className="back-color">
                  <span className="fa fa-paper-plane" aria-hidden="true"></span>
                  <h4>
                    <Link to="/customer_services" className="title-head"> 
                      Customer On-boarding
                    </Link>
                  </h4>
                  <p className="para">
                    Worried about migrating from your existing customer
                    relationship management solutions. Our migration system,
                    switch, helps you bring all your existing sales data into{" "}
                    {`${project_name}`} in just a few clicks.
                  </p>
                </div>
              </div>
              <div className=" grids-effect-2 col-lg-4 col-md-6 col-sm-6 mt-4 pt-1">
                <div className="back-color">
                  <span className="fa fa-inr" aria-hidden="true"></span>
                  <h4>
                    <Link to="/pricing" className="title-head"> 
                      No Hidden Costs
                    </Link>
                  </h4>
                  <p className="para">
                    With {`${project_name}`}, there are no forced contracts or
                    additional surprise costs. What you pay for is what you get.
                    The pricing is flexible as well you can opt to pay either
                    monthly or annually.
                  </p>
                </div>
              </div>
              <div className="grids-effect-2 col-lg-4 col-md-6 col-sm-6 mt-4 pt-1 ">
                <div className="back-color">
                  <span className="fa fa-industry" aria-hidden="true"></span>
                  <h4>
                    <Link to="/crmmarketing" className="title-head">  
                      Marketing
                    </Link>
                  </h4>
                  <p className="para">
                    Marketing software to help you grow traffic, convert more
                    visitors, and run complete inbound marketing campaigns at
                    scale.
                  </p>
                </div>
              </div>

              <div className="left-text">
                <br />
                <br />
                <h3 style={{ fontSize: "35px" }}>
                  The ERP Platform Your Whole Business Will Love
                </h3>
                <br />
                <br />
                <p className="para">
                  {`${project_name}`} platform has all the tools and
                  integrations you need for marketing, sales, content
                  management, and customer service.
                  <br />
                  Each feature in the platform is powerful alone, but the real
                  magic happens when you use them together.
                </p>
                <br />
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}